import { LWTApiClient } from '@/infrastructures/api/LWTApi';
import { TConciergeData } from '@/types/responses/common';

const CONCIERGE_PULLDOWN = '/concierge-list-pulldown/';

export class ConciergePulldownApi {
  static async post(): Promise<TConciergeData[] | null> {
    const apiClient = new LWTApiClient({});
    const res = await apiClient.post<TConciergeData[]>(CONCIERGE_PULLDOWN);
    return res.isError ? [] : res.data;
  }
}
